import { defineComponent as t } from "vue";
const r = t({
  name: "MsJsonLd",
  props: {
    jsonLd: {
      type: Object,
      required: !0
    }
  },
  setup({ jsonLd: n }) {
    return {
      jsonLdString: JSON.stringify(n)
    };
  }
});
export {
  r as default
};
